import angular from 'angular';
import {
  FORM,
  FORM_SUBMIT_INIT,
  FORM_SUBMIT_SUCCESS,
  FORM_SUBMIT_ERROR,
  FORM_EDIT_INIT,
  FORM_EDIT_SUCCESS,
  FORM_EDIT_ERROR,
  FORM_REMOVE_INIT,
  FORM_REMOVE_SUCCESS,
  FORM_REMOVE_ERROR
} from './action-types';

export function formReducer(state = {}, { payload, type }) {
  let model = angular.isArray(payload) ? payload[0] : payload;

  switch (type) {
    case FORM:
      return Object.assign({}, state, {
        flags: { submitted: false },
        created: undefined,
        error: undefined,
        removed: false,
        model: {},
        notFound: undefined
      });
    case FORM_EDIT_INIT:
    case FORM_REMOVE_INIT:
    case FORM_SUBMIT_INIT:
      return Object.assign({}, state, {
        flags: { submitted: false },
        created: undefined,
        error: undefined,
        removed: false,
        notFound: undefined
      });
    case FORM_SUBMIT_SUCCESS:
      return Object.assign({}, state, {
        flags: { submitted: false },
        created: payload,
        model: {},
        notFound: undefined
      });
    case FORM_SUBMIT_ERROR:
    case FORM_EDIT_ERROR:
    case FORM_REMOVE_ERROR:
      return Object.assign({}, state, {
        error: payload || { message: 'Error de comunicación con el servidor' },
        flags: { submitted: false },
        created: undefined,
        notFound: undefined
      });
    case FORM_EDIT_SUCCESS:
      return Object.assign({}, state, {
        flags: { submitted: true },
        model,
        notFound: !model
      });
    case FORM_REMOVE_SUCCESS:
      return Object.assign({}, state, {
        removed: true
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/services/form/reducer.js